import {
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  OnDestroy,
  HostBinding,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
  Renderer2,
  Directive,
} from "@angular/core";

import { DataTable } from "@bfx/primeng/datatable";
import { Calendar } from "@bfx/primeng/calendar";
import { DomHandler } from "@bfx/primeng/dom";

import { TranslateService } from "@ngx-translate/core";

import { BigNumber } from "shared/cubiq-model-multi-asset";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { DatePipe, DecimalPipe } from "@angular/common";
import { BfxAmountSpinnerComponent } from "../bfx-interface-controls/bfx-amount-spinner.component";
import { BfxRateSpinnerComponent } from "../bfx-interface-controls/bfx-rate-spinner.component";
import { BfxAutoCompleteComponent } from "../bfx-element-library/bfx-autocomplete.component";

import * as Constants from "../bfx-blotter-filter/models/bfx-blotter-filter.constants";

import {
  AutoCompleteLabelValue,
  TableDefinition,
  ColumnFilterType,
  UserPromiseLookupService,
  AccountPromiseLookupService,
  ClientPromiseLookupService,
  TraderGroupPromiseLookupService,
  SalesGroupPromiseLookupService,
  CcyPromiseLookupService,
  CcyPairPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  BranchPromiseLookupService,
  FixingSourcePromiseLookupService,
  FilterOrderTypes,
  BenchmarkFixingPrimaryLookupService,
  CustomFieldLookupService,
} from "shared/cubiq-services";

import { ActiveUserProfilePromiseService } from "shared/auth-services";
import { ActiveUser, SystemConfigPromiseService, Roles } from "shared/cubiq-services";

import { BfxBlotterFilterService } from "../bfx-blotter-filter/bfx-blotter-filter.service";

import {
  FilterType,
  BfxBlotterFilter,
  BfxBlotterFilterCondition,
} from "../bfx-blotter-filter/bfx-blotter-filter.constants";

import { BfxFindFilterCondition } from "../bfx-find/models/BfxFindFilterCondition";
import { BfxFindFilterConditionLabels } from "../bfx-find/models/BfxFindFilterConditionLabels";
import { BfxFindFilterOperatorSet } from "../bfx-find/models/BfxFindFilterOperatorSet";
import { BfxBlotterFilterSelectorService } from "../bfx-blotter-filter/bfx-blotter-filter-selector.service";

import { BfxPanelHelperService } from "../bfx-common/services/bfx-panel-helper.service";

import {
  BFX_FIND_OPERATOR_DATA,
  ACCOUNT_FILTER_TYPES,
  CLIENT_FILTER_TYPES,
  FIND_OBJECT_SORT,
  BfxFindOrderStateLive,
  BfxFindOrderFillState,
  BfxFindOrderStateNonLive,
  BFX_FIND_TIMEZONE_CODES,
  BFX_FIND_TIMEZONE_CD_UTC,
} from "../bfx-find/bfx-find.constants";

import { BFX_FIND_DATE_COMPARITOR } from "../bfx-find/bfx-find-date-comparitor.constants";
import { BfxFindFilterDateComparitor } from "../../shared/cubiq-services/model/find/BfxFindFilterDateComparitor";
import { BfxFindService } from "./bfx-find.service";
import { AutoCompleteFilterOrderTypeLabelValue } from "shared/cubiq-services";
import { BfxFindFilterConditionData } from "./models/BfxFindFilterConditionData";
import { FilterData } from "./bfx-find.constants";
import { BfxOrderEntryTimeControlModel } from "../bfx-interface-controls/models/bfx-interface-controls.models";
import { BfxMultiSelectorComponent } from "../bfx-element-library/bfx-multi-selector.component";
import { BfxInputControlStateEnum } from "../bfx-interface-controls/models/bfx-interface-controls.enums";
import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import { LoggerService } from "@bfx/logger";

const logger = LoggerService.for(__dirname);
@Directive()
export abstract class BfxFindFilterView implements OnDestroy {
  @ViewChild("outerDt")
  protected outerDt: DataTable;

  @ViewChildren("dt")
  protected dtExpandedQueryList: QueryList<DataTable>;

  @ViewChildren(Calendar)
  public calendarComponents: QueryList<Calendar>;

  @ViewChildren("headerToggleElement")
  protected headerToggleElements: QueryList<ElementRef>;

  @Output()
  public expandedChange: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public selectSearch: EventEmitter<void> = new EventEmitter<void>();

  public autocompletePanelHelper: Element = null;
  public calendarPanelHelper: Element = null;

  public editableFilter: any;

  public async_data: Promise<FilterData[]> | null = null;
  public data: FilterData[] = null;
  protected isDataPrimed = false;

  public columnFilterTypes = {};

  // revise if not runtime readonly
  protected _headingsCache = null;
  public emptyMessage: string;

  public filterType: FilterType = null;

  public columns: any = {};

  public columnOptions: Array<any> = [];
  public columnSuggestions: Array<any> = [];
  public operatorSuggestions: Array<any> = [];
  public operatorAutoHighlightIndex: number = 0;
  public timezoneSuggestions: Array<any> = [...BFX_FIND_TIMEZONE_CODES];
  public timezoneCdAutoHighlightIndexes: number = 0;

  public dateComparitorSuggestions = {
    value: [...BFX_FIND_DATE_COMPARITOR],
    from: [...BFX_FIND_DATE_COMPARITOR],
    to: [...BFX_FIND_DATE_COMPARITOR],
  };

  public timezoneCdSuggestions = {
    value: [...BFX_FIND_TIMEZONE_CODES],
  };
  public dateComparitorAutoHighlightIndexes = {
    value: 0,
    from: 0,
    to: 0,
  };

  public valueSuggestions: Array<any> = [];
  public objectSuggestions: Array<any> = [];
  public currencyPairGroupData: Array<any> = [];

  public objectColumns: any = {};

  public saving: boolean = false;
  public blotterId: string = null;

  /** Map between column ID and a list of values allow for the column */
  public objectValues: any = {};
  public objectValuesLookupFn: any = {};

  public _editedItem: BfxBlotterFilter;
  public _sliderValue: boolean = false;

  public saveAfterOr: false;
  public edit: boolean;
  public ccyPairGroupFirst: string = "group";
  public itemCounter: number = 0;

  public timeInput: any = {
    timeValue: null,
    timezoneValue: null,
    from: {
      timeValue: null,
      timezoneValue: null,
    },
    to: {
      timeValue: null,
      timezoneValue: null,
    },
  };

  public multipleOperators: any = {};
  public betweenOperators: any = {};
  public equalNotEqualOperators: any = {};
  public equalOperator: any = {};

  public tableDefinition: TableDefinition = null;

  public currentEditableInit = null;
  public currentEditableData = null;
  public currentEditableColumn = null;
  public currentEditableSection: number = null;

  @HostBinding("class.find__filter_view")
  public readonly _bemId: boolean = true;

  protected primaryTypeName: string = null;

  protected filterRequestObservableSubscr: any;
  protected clearRequestSubjectSubscr: any;

  // focus helpers
  protected editableColumnInputMap = new WeakMap();
  protected editableColumnDropdownMap = new WeakMap();
  protected editableColumnCalendarMap = new WeakMap();
  protected editableColumnOperatorMap = new WeakMap();
  protected editableColumnBetweenProxyMap = new WeakMap();
  protected editableColumnTimeInputMap = new WeakMap();
  // real target
  protected editableColumnValueMap = new WeakMap();

  protected headerMap = new WeakMap();
  protected currentEditableDropdownData = null;
  protected _dateClickComponent = null;
  protected _dateClickField = null;
  protected _timeClickComponent = null;
  protected _timeClickField = null;

  protected showUserName: boolean;

  // css helper
  protected activeRowMap = new Map<number, Set<number>>();
  protected invalidValueRowMap = new Map<number, Set<number>>();

  public activeRows = [];
  public betweenOperatorRows = [];

  public hasActiveRow: boolean = false;

  protected betweenOperatorRowsMap = new Map<number, Set<number>>();
  protected clientTraderUsersEnabled = true;
  protected fwdEnabled = true;
  protected ndfEnabled = true;
  public benchmarksEnabled = true;

  private _tabCancelableTimeoutId: any;
  private _tabCancelableTimeoutId2: any;

  protected readonly ALL_CLIENT_TRADERS = "ALL_CLIENT_TRADERS";

  /** All active custom fields  */
  protected customFieldDefns: CubiqTS.CustomFieldImpl[] = [];

  /** Map of attribute element text vs the corresponding overflow state  */
  private attributeOverflowMap: Map<string, boolean> = new Map();

  constructor(
    public blotterService: BfxBlotterFilterService,
    public translationService: TranslateService,
    public userService: UserPromiseLookupService,
    public accountService: AccountPromiseLookupService,
    public clientService: ClientPromiseLookupService,
    public traderGroupService: TraderGroupPromiseLookupService,
    public salesGroupService: SalesGroupPromiseLookupService,
    public branchLookupService: BranchPromiseLookupService,
    public ccyService: CcyPromiseLookupService,
    public ccyPairService: CcyPairPromiseLookupService,
    public currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
    protected datePipe: DatePipe,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected selectorService: BfxBlotterFilterSelectorService,
    protected panelHelper: BfxPanelHelperService,
    public domHandler: DomHandler,
    public cd: ChangeDetectorRef,
    protected decimalFormatter: DecimalPipe,
    protected systemConfigLookup: SystemConfigPromiseService,
    protected findService: BfxFindService,
    protected fixingSourceService: FixingSourcePromiseLookupService,
    protected bmFixingSourceService: BenchmarkFixingPrimaryLookupService,
    protected customFieldService: CustomFieldLookupService,
    renderer: Renderer2,
    protected el: ElementRef,
  ) {
    BfxFindFilterConditionLabels.forEach((operator: any) => {
      let multiple: boolean =
        operator.value == CubiqTS.Operator.In || operator.value == CubiqTS.Operator.NotIn;
      this.multipleOperators[operator.value] = multiple;
      let between: boolean =
        operator.value == CubiqTS.Operator.Between || operator.value == CubiqTS.Operator.NotBetween;
      this.betweenOperators[operator.value] = between;
      const equal: boolean = operator.value == CubiqTS.Operator.Equal;
      let equalNotEqual: boolean = equal || operator.value == CubiqTS.Operator.NotEqual;
      this.equalOperator[operator.value] = equal;
      this.equalNotEqualOperators[operator.value] = equalNotEqual;
    });

    this.calendarPanelHelper = this.panelHelper.getPanel("find__calendar_panel_helper", renderer);
    this.autocompletePanelHelper = this.panelHelper.getPanel(
      "find__autocomplete_panel_helper",
      renderer,
    );

    this.clearRequestSubjectSubscr = this.findService.getClearRequestSubject().subscribe(() => {
      this.onClearRequest();
    });
  }

  public onClearRequest(): void {
    this.cd.markForCheck();

    this.data.forEach((fd: FilterData, i) => {
      if (this.outerDt.isRowExpanded(this.data[i])) {
        this.toggleRow(this.outerDt, this.data[i], null, i);
      }

      fd.isRowExpanded = false;
      fd.expandedIndex = -1;

      fd.filterConditions.forEach((fc: BfxFindFilterCondition) => {
        if (fc.fieldName == "timezoneCd") {
          fc.value = BFX_FIND_TIMEZONE_CD_UTC;
          fc.operatorData = { label: "=", value: 2 };
        } else {
          fc.value = null;
          fc.operatorData = null;
        }
        fc.from = null;
        fc.to = null;
        fc.implictOperator = false;
        fc.input = new BfxFindFilterConditionData();
        fc.calendar = new BfxFindFilterConditionData();
        fc.hasRowExpanded = false;
        fc.showTooltip = {
          value: false,
          from: false,
          to: false,
        };
      });
    });

    this.activeRowMap.clear();
    this.hasActiveRow = false;
    this.betweenOperatorRowsMap.clear();
    this.activeRows = [];
    this.betweenOperatorRows = [];
    this.resetVisibleClientTraderData();

    Object.keys(this.objectValues).forEach((fieldName) =>
      this.objectValues[fieldName].forEach((a) => (a["checked"] = false)),
    );

    setTimeout(() => {
      this.expandedChange.emit();
    }, 4);
  }

  public abstract initNonTableFindFields(): void;
  public abstract primeTraderGroupData(colDef: BfxColDef, values: CubiqTS.TradingGroupImpl[]): void;
  public abstract primeOrderTypeData(colDef: BfxColDef, values: any[]): void;

  public scrollHandler($event) {
    // OMS-33703 click document level click to close open autocomplete after a scroll
    try {
      this.el.nativeElement.ownerDocument.dispatchEvent(new Event("click"));
    } catch (e) {
      // best effort only - skip logging error
    }
  }

  public initTableDefinition(tableDefinition: TableDefinition): void {
    this.tableDefinition = tableDefinition;

    this.objectValues = {};
    this.objectColumns = {};
    this.columnOptions = [];
    this.columns = {};

    this.tableDefinition.columns.forEach((columnDef: BfxColDef) => {
      if (columnDef.columnFilterType != ColumnFilterType.NONE) {
        let label = columnDef.headerTooltip
          ? columnDef.headerTooltip.replace(/<.*?>/g, "").trim()
          : columnDef.headerName.replace(/<.*?>/g, "").trim();

        this.columns[columnDef.field] = columnDef;
        this.columnOptions.push({ label: label, value: columnDef.field });

        let columnKeys: any = {};
        let columnKey: string =
          columnDef.columnFilterType +
          "-" +
          (columnDef.columnFilterData && columnDef.columnFilterData["RemoteClass"]
            ? columnDef.columnFilterData.RemoteClass()
            : null);

        if (!columnKeys[columnKey]) {
          columnKeys[columnKey] = true;
          this.primeData(columnDef);
        }

        this.objectColumns[columnDef.field] =
          Constants.OBJECT_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0;
        this.columnFilterTypes[columnDef.field] = ColumnFilterType[columnDef.columnFilterType];
      }
    });

    this.columnOptions.sort(FIND_OBJECT_SORT);
  }

  /**
   * Set up the custom fields in the model, ensuring that the filter type, domain values, and flags
   * are setup correctly for each active custom field
   */
  protected initCustomFields(): void {
    this.customFieldDefns = this.customFieldService.getActiveCustomFields();

    this.customFieldDefns.forEach((field) => {
      const fieldName = this.customFieldService.getEntityPropertyName(field);
      if (field.freeFormatTxtFg) {
        this.columnFilterTypes[fieldName] = "STRING";
      } else {
        // Create a unique data source ID based on ther custom field name
        this.columnFilterTypes[fieldName] = field.fieldId;
        // Define the members of the data source
        this.objectValues[fieldName] = field.domainValues
          ? field.domainValues.map((value) => {
              return { label: value, value };
            })
          : [];
        // Mark the column as containing value objects
        this.objectColumns[fieldName] = true;
      }
    });
  }

  public primeData(columnDef: BfxColDef): void {
    let primedData: any = null;

    if (columnDef && columnDef.columnFilterType == ColumnFilterType.ENUM) {
      let keys: string[] = Object.keys(columnDef.columnFilterData);
      let name: string = columnDef.columnFilterData.name;
      let length: number = keys.length - 2;
      keys = keys.splice(length / 2, length / 2);
      if (columnDef.headerName == "Product") {
        this.blotterService
          .loadProductDataset(
            keys,
            false,
            this.tableDefinition.benchmarkTableDefinition,
            this.primaryTypeName,
          )
          .then((res) => {
            keys = res;
            let values: any = keys.map((a) => {
              return {
                label: this.translationService.instant(
                  "column.filter." + columnDef.field + "." + a,
                ),
                value: a,
              };
            });
            primedData = values.sort(FIND_OBJECT_SORT);
            this.objectValues[columnDef.field] = primedData;
            this.processProductPrimeData(columnDef);
          });
      } else {
        let values: any = keys.map((a) => {
          return {
            label: this.translationService.instant("column.filter." + columnDef.field + "." + a),
            value: a,
          };
        });
        primedData = values.sort(FIND_OBJECT_SORT);
        this.objectValues[columnDef.field] = primedData;
      }
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.ACCOUNT) {
      this.accountService.isPrimed().then(() => {
        this.accountService
          .getLabelValueByName({
            prefix: null,
            skip: 0,
          })
          .then((primedData: AutoCompleteLabelValue[]) => {
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
              this.objectValuesLookupFn[c.field] = this.accountService.getLabelValueByName.bind(
                this.accountService,
              );
            });
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.ACCOUNTID) {
      this.accountService.isPrimed().then(() => {
        this.accountService
          .getLabelValueById({
            prefix: null,
            skip: 0,
          })
          .then((primedData: AutoCompleteLabelValue[]) => {
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
              this.objectValuesLookupFn[c.field] = this.accountService.getLabelValueById.bind(
                this.accountService,
              );
            });
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.CLIENT) {
      this.clientService.isPrimed().then(() => {
        this.clientService
          .getLabelValueByName({
            prefix: null,
            skip: 0,
          })
          .then((primedData: AutoCompleteLabelValue[]) => {
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
              this.objectValuesLookupFn[c.field] = this.clientService.getLabelValueByName.bind(
                this.clientService,
              );
            });
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.CLIENTID) {
      this.clientService.isPrimed().then(() => {
        this.clientService
          .getLabelValueById({
            prefix: null,
            skip: 0,
          })
          .then((primedData: AutoCompleteLabelValue[]) => {
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
              this.objectValuesLookupFn[c.field] = this.clientService.getLabelValueById.bind(
                this.clientService,
              );
            });
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.BRANCH) {
      this.branchLookupService.isPrimed().then(() => {
        this.branchLookupService.getCompleteListOfBranchCodes().then((values: Array<string>) => {
          if (values) {
            primedData = values
              .filter((a) => a != "System")
              .map((a) => {
                return { label: a, value: a };
              })
              .sort(FIND_OBJECT_SORT);
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
            });
          }
        });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.TRADERGROUP) {
      this.traderGroupService.isPrimed().then(() => {
        this.traderGroupService.getAll().then((values: Array<CubiqTS.TradingGroupImpl>) => {
          this.primeTraderGroupData(columnDef, values);
        });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.SALESGROUP) {
      this.salesGroupService.isPrimed().then(() => {
        this.salesGroupService.getAll().then((values: Array<CubiqTS.SalesGroupImpl>) => {
          if (values) {
            primedData = values
              .map((a) => {
                return { label: a.groupCode, value: a.groupId };
              })
              .sort(FIND_OBJECT_SORT);
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
            });
          }
        });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.CURRENCY_PAIR) {
      this.ccyPairService.isPrimed().then(() => {
        this.ccyPairService.getAll().then((values: Array<CubiqTS.CurrencyPairImpl>) => {
          if (values) {
            let currencies: any = {};
            let currencyPairs: Array<any> = values.map((a) => {
              currencies[a.base] = currencies[a.nonBase] = true;
              return { label: a.base + a.nonBase, value: a.base + a.nonBase };
            });

            primedData = currencyPairs.sort((a, b) => {
              return a.label.localeCompare(b.label);
            });

            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
            });
          }
        });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.ORDERSTATE) {
      this.systemConfigLookup.hasRole(Roles.VIEW_FIND_LIVE_ORDERS).then(
        (hasFindLiveOrders) => {
          let keys: string[];

          if (hasFindLiveOrders) {
            this.benchmarksEnabled
              ? this.primeOrderStates(columnDef, {
                  ...BfxFindOrderStateLive,
                  ...BfxFindOrderFillState,
                })
              : this.primeOrderStates(columnDef, BfxFindOrderStateLive);
          } else {
            this.primeOrderStates(columnDef, BfxFindOrderStateNonLive);
          }
        },
        (reason) => {
          this.primeOrderStates(columnDef, BfxFindOrderStateNonLive);
        },
      );
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.ORDERTYPE) {
      let keys: any[] = Object.keys(columnDef.columnFilterData);
      keys = keys.splice(keys.length / 2, keys.length / 2);
      this.blotterService
        .loadOrderTypeDataset(keys, true, this.tableDefinition.benchmarkTableDefinition)
        .then((value) => {
          let keys = value;
          let values: any = keys.map((a: string | AutoCompleteFilterOrderTypeLabelValue) => {
            if (a instanceof AutoCompleteFilterOrderTypeLabelValue) {
              return a;
            }
            return new AutoCompleteFilterOrderTypeLabelValue(
              FilterOrderTypes[a],
              this.translationService.instant("column.filter." + columnDef.field + "." + a),
              a,
            );
          });

          if (values) {
            this.primeOrderTypeData(columnDef, values);
          }
        });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.CHANNEL) {
      this.clientService.isPrimed().then(() => {
        this.clientService
          .getTradingChannels()
          .then((values: Array<CubiqTS.TradingChannelProfileImpl>) => {
            if (values) {
              primedData = values
                .map((a: CubiqTS.TradingChannelProfileImpl) => {
                  return {
                    label: a.tradingSourceDisplayName,
                    value: a.channelId,
                  };
                })
                .sort(FIND_OBJECT_SORT);
              let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
                (c) => c.columnFilterType == columnDef.columnFilterType,
              );
              columnDefs.forEach((c) => {
                this.objectValues[c.field] = primedData;
              });
            }
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.FIXCODE) {
      if (this.ndfEnabled) {
        this.fixingSourceService.isPrimed().then(() => {
          this.fixingSourceService.getAll().then((values: Array<CubiqTS.NdfSourceImpl>) => {
            if (values) {
              primedData = values
                .map((a: CubiqTS.NdfSourceImpl) => {
                  return {
                    label: "(" + a.ccyPair + ")" + " " + a.fixingCode,
                    value: a.id,
                  };
                })
                .sort(FIND_OBJECT_SORT);
              primedData.push({
                label: this.translationService.instant("fixingSource.custom"),
                value: -1,
              });
              let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
                (c) => c.columnFilterType == columnDef.columnFilterType,
              );
              columnDefs.forEach((c) => {
                this.objectValues[c.field] = primedData;
              });
            }
          });
        });
      }
    }
  }

  public primeClientTraderUserData(
    allValuesField: string,
    visibleValuesField: string,
    values: CubiqTS.UserImpl[],
    activeUser: ActiveUser,
  ): void {
    if (values) {
      let clientTraderData = values
        .filter((a) => {
          return a.userType === CubiqTS.UserType.CLIENT_TRADER;
        })
        .map((a) => {
          return {
            label: `(${a.clientCode}) ${a.userName}`,
            value: a.userId,
            type: a.userType,
            clientIds: a.clientCodes,
          };
        })
        .sort(FIND_OBJECT_SORT);

      this.objectValues[allValuesField] = clientTraderData; // unfiltered - but not seen by controls
      this.filterVisibleClientTraderData(visibleValuesField);
    }
  }

  public primeOrderStates(columnDef, orderStates): void {
    let keys = Object.keys(orderStates);
    let values: any = keys.map((a) => {
      return {
        label: this.translationService.instant("find.orders.state." + a),
        value: a,
      };
    });

    if (values) {
      let primedData = values.sort(FIND_OBJECT_SORT);
      this.objectValues[columnDef.field] = primedData;
    }
  }

  public primeUserData(
    fieldName: string,
    values: CubiqTS.UserImpl[],
    activeUser: ActiveUser,
  ): void {
    let primedData = values
      .filter((a) => a.userType !== CubiqTS.UserType.CLIENT_TRADER)
      .map((a) => {
        return {
          label: this.showUserName === true ? a.userName : a.userCode,
          value: a.userId,
          type: a.userType,
        };
      })
      .sort(FIND_OBJECT_SORT);

    this.objectValues[fieldName] = primedData;
    this.objectColumns[fieldName] = true;
  }

  ngOnDestroy(): void {
    this.filterRequestObservableSubscr.unsubscribe();
    this.clearRequestSubjectSubscr.unsubscribe();
    this.panelHelper.destroy(this.calendarPanelHelper);
    this.panelHelper.destroy(this.autocompletePanelHelper);
  }

  public filterContents(index, dt) {
    if (!this.isDataPrimed) {
      return undefined;
    }

    this.data[index].dt = dt;

    return this.data[index].filterConditions;
  }

  public rowStyleClass(data: any): string {
    if (data.or) return "bfx-filter-or";
    return data && !(data.add || data.or) ? "editable" : "non-editable";
  }

  public get editedItem(): BfxBlotterFilter {
    return this._editedItem;
  }

  public set editedItem(editedItem: BfxBlotterFilter) {
    this._editedItem = editedItem;

    if (this._editedItem != null) {
      this.emptyMessage = this.translationService.instant("filter.manager.no.rules");
    } else {
      this.emptyMessage = this.translationService.instant("filter.manager.no.filter.selected");
    }
  }

  public selectOption(data: any, event: any) {
    if (event.alternativeActive != null) {
      if (event.alternativeActive) {
        data.altValue = event.selectedOptions;
      } else {
        data.value = event.selectedOptions;
      }
    } else {
      data.value = event;
    }
  }

  public getColumnOptions(data: any): Array<any> {
    let index: number = this._editedItem.conditions.indexOf(data);

    let conditionQuery: string = null;
    if (data.conditionData.value === undefined) {
      conditionQuery = data.conditionData;
      data.conditionData = { label: data.fieldTitle, value: data.fieldName };
    }

    let startIndex: number = 0;
    for (let i: number = index; i >= 0 && startIndex == 0; i--) {
      if (this._editedItem.conditions[i].or) {
        startIndex = i + 1;
      }
    }

    let endIndex: number = this.editedItem.conditions.length;
    for (let i: number = index; i < this._editedItem.conditions.length; i++) {
      if (this._editedItem.conditions[i].or) {
        endIndex = i;
      }
    }

    let group: Array<BfxBlotterFilterCondition> = this._editedItem.conditions.slice(
      startIndex,
      endIndex,
    );
    let groupFields: Array<string> = group.map(
      (condition: BfxBlotterFilterCondition) => condition.conditionData.value,
    );

    let hasAccount: boolean =
      group.filter((member: BfxBlotterFilterCondition) => {
        let colDef: BfxColDef = this.columns[member.conditionData.value];
        return colDef != null && ACCOUNT_FILTER_TYPES.indexOf(colDef.columnFilterType) >= 0;
      }).length > 0;

    let hasClient: boolean =
      group.filter((member: BfxBlotterFilterCondition) => {
        let colDef: BfxColDef = this.columns[member.conditionData.value];
        return colDef != null && CLIENT_FILTER_TYPES.indexOf(colDef.columnFilterType) >= 0;
      }).length > 0;

    let options: Array<any> = this.columnOptions.filter(
      (option: any) => groupFields.indexOf(option.value) < 0,
    );

    if (hasAccount) {
      options = options.filter((option: any) => {
        let colDef: BfxColDef = this.columns[option.value];
        return colDef != null && ACCOUNT_FILTER_TYPES.indexOf(colDef.columnFilterType) < 0;
      });
    }

    if (hasClient) {
      options = options.filter((option: any) => {
        let colDef: BfxColDef = this.columns[option.value];
        return colDef != null && CLIENT_FILTER_TYPES.indexOf(colDef.columnFilterType) < 0;
      });
    }

    options.push(data.conditionData);

    if (data.conditionData.label == null) {
      data.conditionData.label = "";
    }

    options.sort(FIND_OBJECT_SORT);

    if (options[0].value == null || options[0].value == "") {
      options.splice(0, 1);
    }

    if (conditionQuery != null) {
      data.conditionData = conditionQuery;
    }

    return options;
  }

  public searchColumn(event: any, data: any): void {
    let query: string = event.query.toLowerCase();
    this.columnSuggestions = this.getColumnOptions(data).filter(
      (a) => a.label.toLowerCase().indexOf(query) >= 0,
    );
  }

  public showColumnOptions(event: any, data: any): any {
    return this.getColumnOptions(data);
  }

  public onDateComparitorChanged($event: any, data: any) {
    if (null != $event && null != $event.value && BfxFindFilterDateComparitor[$event.value]) {
      data.input.value = $event;
      data.calendar.value = null;
      data.value = BfxFindFilterDateComparitor[$event.value];

      this.updateActiveRowState(data);
      this.updateBetweenOperatorState(data);
    } else {
      data.input.value = null;

      if (data.calendar.value == null) {
        data.value = null;
      }
    }
  }

  public onTimeInputChanged(
    value: BfxOrderEntryTimeControlModel,
    data: BfxFindFilterCondition,
    valueField: string = `value`,
  ): void {
    data.calendar[valueField] = null;
    data.input[valueField] = value;

    data[valueField] = value;

    let timeInputComponent = this.editableColumnTimeInputMap.get(data)[valueField];

    if (
      timeInputComponent != null &&
      timeInputComponent.data.state !== BfxInputControlStateEnum.INVALID &&
      value.timeValue &&
      value.timezoneValue
    ) {
      this.updateTimeMask(data);
      this.updateActiveRowState(data);
      this.updateBetweenOperatorState(data);

      this.cd.detectChanges();
    }
  }

  public onDateComparitorFromCalendar($event, data, valueField = `value`) {
    data.calendar[valueField] = $event;
    data.input[valueField] = null;

    data[valueField] = $event;

    this.updateActiveRowState(data);
    this.updateBetweenOperatorState(data);

    this.cd.detectChanges();
  }

  public searchDateComparitor(event: any, data: any, valueField = `value`) {
    if (data.fieldName === undefined) {
      return;
    }

    const query: string = event.query.toLowerCase();
    const fullMatchSuggestions = [];
    const weakMatchSuggestions = [];
    let fullIndex = -1;
    let weakIndex = -1;
    let autoIndex = 0;

    BFX_FIND_DATE_COMPARITOR.forEach((operator, index) => {
      let isMatchExisting = data.hasOperator && data.operator == operator.value;

      if (operator.label.toLowerCase() === query) {
        if (isMatchExisting) {
          fullIndex = fullMatchSuggestions.length;
        }

        fullMatchSuggestions.push(operator);
      } else if (operator.label.toLowerCase().indexOf(query) >= 0) {
        if (isMatchExisting) {
          weakIndex = weakMatchSuggestions.length;
        }

        weakMatchSuggestions.push(operator);
      }
    });

    // filter creates a new address, forcing change detect.
    if (valueField === `value` || valueField === `from` || valueField === `to`) {
      this.dateComparitorSuggestions[valueField] = [
        ...fullMatchSuggestions,
        ...weakMatchSuggestions,
      ];

      if (fullIndex >= 0) {
        autoIndex = fullIndex;
      } else if (weakIndex >= 0) {
        autoIndex = fullMatchSuggestions.length + weakIndex;
      } else {
        autoIndex = 0;
      }

      this.dateComparitorAutoHighlightIndexes[valueField] = autoIndex;
    }
  }

  public showTimezoneCdOptions(event: any, data: any) {
    if (data.conditionData.value === undefined) {
      this.timezoneSuggestions = [];
      return;
    }

    this.timezoneSuggestions = this.timezoneCdSuggestions.value.map((operator, i) => {
      if (data.hasOperator && data.operator == operator.value) {
        this.timezoneCdAutoHighlightIndexes = i;
      }

      return operator;
    });
  }

  public searchTimezoneCd(event: any, data: any) {
    if (data.fieldName === undefined) {
      return;
    }

    const query: string = event.query.toLowerCase();
    const fullMatchSuggestions = new Set();
    const weakMatchSuggestions = new Set();
    let fullIndex = -1;
    let weakIndex = -1;

    this.timezoneCdSuggestions.value.forEach((operator, index) => {
      let isMatchExisting = data.hasOperator && data.operator == operator.value;

      if (operator.label.toLowerCase() === query) {
        if (isMatchExisting) {
          fullIndex = fullMatchSuggestions.size;
        }

        fullMatchSuggestions.add(operator);
      } else if (operator.label.toLowerCase().indexOf(query) >= 0) {
        if (isMatchExisting) {
          weakIndex = weakMatchSuggestions.size;
        }

        weakMatchSuggestions.add(operator);
      }
    });

    this.timezoneSuggestions = [...fullMatchSuggestions, ...weakMatchSuggestions];

    if (fullIndex >= 0) {
      this.timezoneCdAutoHighlightIndexes = fullIndex;
    } else if (weakIndex >= 0) {
      this.timezoneCdAutoHighlightIndexes = fullMatchSuggestions.size + weakIndex;
    } else {
      this.timezoneCdAutoHighlightIndexes = 0;
    }
  }

  public onTimezoneCdChanged($event, data) {
    if (
      null != $event &&
      null != $event.value &&
      this.timezoneCdSuggestions.value.some((el) => el.value === $event.value)
    ) {
      let value = this.timezoneCdSuggestions.value.find((el) => el.value == $event.value);
      data.input[`value`] = $event;
      data[`value`] = value;

      this.updateActiveRowState(data);
      this.updateBetweenOperatorState(data);
    } else {
      data.input[`value`] = null;
      data[`value`] = null;
    }
  }

  public showDateComparitorOptions(event: any, data: any, valueField = `value`) {
    let suggest = [...BFX_FIND_DATE_COMPARITOR];

    if (valueField === `value` || valueField === `from` || valueField === `to`) {
      this.dateComparitorSuggestions[valueField] = suggest;
    }
  }

  public showOperatorOptions(event: any, data: any) {
    if (data.conditionData.value === undefined) {
      this.operatorSuggestions = [];
      return;
    }

    const suggestions = [];
    let activeIndex = -1;
    BFX_FIND_OPERATOR_DATA.get(data.availableOperators).forEach((operator, index) => {
      suggestions.push(operator);
      if (data.hasOperator && data.operator == operator.value) {
        activeIndex = index;
      }
    });

    this.operatorSuggestions = suggestions;
    this.operatorAutoHighlightIndex = activeIndex >= 0 ? activeIndex : 0;
  }

  public searchOperator(event: any, data: any) {
    // Create a new array so that the Autocomplete will rerun its query matching
    this.operatorSuggestions = [...this.operatorSuggestions];
  }

  public searchValue(event: any, data: any): void {
    logger.out.warn(`${this.constructor.name}.searchValue() no-op`);
  }

  public showValueOptions(event: any, data: any): void {
    logger.out.warn(`${this.constructor.name}.showValueOptions() no-op`);
  }

  public saveData(): object[] {
    return Array.from(this.data).map((heading: any) => {
      return heading.filterConditions.map((filterCondition) => {
        return filterCondition.saveData();
      });
    });
  }

  public restoreData(data: any) {
    // close all outerDt
    data.forEach((filterConditions, i) => {
      if (this.outerDt.isRowExpanded(this.data[i])) {
        this.toggleRow(this.outerDt, this.data[i], null, i);
      }
    });

    data
      .filter((f) => Array.isArray(f))
      .forEach((filterConditions, i) => {
        if (this.outerDt.isRowExpanded(this.data[i])) {
          this.toggleRow(this.outerDt, this.data[i], null, i);
        }

        filterConditions.forEach((filterCondition, j) => {
          let currentFieldIndex = j;
          const fieldName = filterCondition.fieldName;
          if (fieldName !== this.data[i]?.filterConditions[currentFieldIndex]?.fieldName) {
            // If oboEnabled has changed, or clienttrader then data may not match filterCondition structure
            // Field is not where we expect it so find the actual index
            logger.out.info(
              `find-fv-c - mismatch in restoring ${fieldName} at position ${j} - locating manually`,
            );
            currentFieldIndex = this.findMovedFilterField(
              fieldName,
              this.data[i]?.filterConditions,
            );
          }

          if (currentFieldIndex !== -1) {
            const viewCondition = this.data[i].filterConditions[currentFieldIndex];
            const validatedCondition = this.validateFilterCondition(filterCondition);
            viewCondition.restoreData(validatedCondition);
            this.selectOption(validatedCondition, {
              alternativeActive: false,
              selectedOptions: validatedCondition.value,
            });
            this.updateTimeMask(viewCondition);
            this.updateActiveRowState(viewCondition);
            this.updateBetweenOperatorState(viewCondition);

            if (viewCondition.operator !== null && !this.outerDt.isRowExpanded(this.data[i])) {
              this.toggleRow(this.outerDt, this.data[i], null, i);
            }
          } else {
            logger.out.info(
              `find-fv-c - Cannot find filter condition ${fieldName} at position ${j} - not restoring`,
            );
          }
        });
      });
    this.cd.detectChanges();
  }

  /**
   * Where a displayed control has moved (e.g. due to a change in config) we will need to manually locate the
   * referenced field inside the group of filter conditions
   *
   * @param fieldName
   * @param filterConditions
   * @returns
   */
  private findMovedFilterField(
    fieldName: string,
    filterConditions: BfxFindFilterCondition[],
  ): number {
    if (Array.isArray(filterConditions)) {
      return filterConditions.findIndex(
        (filterCondition) => filterCondition.fieldName === fieldName,
      );
    }
    return -1;
  }

  /**
   * For all filter conditions that have defined value sets, we check the stored value against the set
   * of allowed values in the obJectValues holder. If there is value that is not in the enumerated data,
   * we remove the value and return a copy of the FilterCondtion for populating into the form (but the stored
   * state remains the same)
   * @param filterCondition
   * @returns
   */
  protected validateFilterCondition(filterCondition: any): any {
    if (filterCondition.operator !== null) {
      const dataset = this.objectValues[filterCondition.fieldName];
      if (Array.isArray(dataset) && Array.isArray(filterCondition.value)) {
        // Create set of allowed values from the cached objectValues using _findValue first, if it exists
        const valueSet = new Set(
          dataset.map((value) => {
            if (typeof value.value === "object") {
              return value.label;
            }
            return (
              value._findValue?.toString() ??
              value.value?.toString() ??
              "<Not Found " + value.label + ">"
            );
          }),
        );

        // Filter the stored values to remove any that are not in the value set
        const newValues = filterCondition.value.filter((value) => {
          let valueStr;
          if (typeof value.value === "object") {
            valueStr = value.label;
          } else {
            valueStr = value.value?.toString() ?? "<Not Found " + value.label + ">";
          }
          if (!valueSet.has(valueStr)) {
            logger.out.warn("find: Rejecting stored value " + valueStr);
            if (value.value === undefined) {
              logger.out.error("No Value");
            }
            return false;
          }
          return true;
        });
        // If we've removed a value, return a whole new FilterCondition
        if (filterCondition.value.length !== newValues.length) {
          return { ...filterCondition, value: newValues };
        }
      }
    }
    return filterCondition;
  }

  public onOperatorChanged(event, data: BfxFindFilterCondition): void {
    let operator;

    if (typeof event == "string") {
      operator = BFX_FIND_OPERATOR_DATA.get(data.availableOperators).find((value) => {
        if (value && value.label && value.label.toLowerCase() === event) {
          return true;
        }
      });
    } else {
      operator = event && CubiqTS.Operator[event.value] ? event.value : null;
    }

    if (
      operator !== null &&
      !this.betweenOperators[data.operator] &&
      this.betweenOperators[operator] &&
      (this.columnFilterTypes[data.fieldName] === `TIME` ||
        data.value instanceof BfxOrderEntryTimeControlModel)
    ) {
      data.from = data.value;
      data.input.from = data.input.value;
      data.calendar.from = data.calendar.value;
      data.value = data.to = null;
      data.input.value = data.input.to = null;
      data.calendar.value = data.calendar.to = null;
    } else if (
      operator !== null &&
      !this.betweenOperators[data.operator] &&
      this.betweenOperators[operator] &&
      (this.columnFilterTypes[data.fieldName] !== `DATE` || data.value instanceof Date)
    ) {
      data.from = data.value;
      data.input.from = data.input.value;
      data.calendar.from = data.calendar.value;
      data.value = data.to = null;
      data.input.value = data.input.to = null;
      data.calendar.value = data.calendar.to = null;
    } else if (
      operator !== CubiqTS.Operator.Equal &&
      this.columnFilterTypes[data.fieldName] === `DATE` &&
      (typeof data.from === "string" || typeof data.value === "string")
    ) {
      data.value = data.from = data.to = null;
      data.input.value = data.input.from = data.input.to = null;
      data.calendar.value = data.calendar.from = data.calendar.to = null;
    } else if (
      operator !== null &&
      !this.betweenOperators[data.operator] &&
      this.betweenOperators[operator]
    ) {
      data.value = data.from = data.to = null;
      data.input.value = data.input.from = data.input.to = null;
      data.calendar.value = data.calendar.from = data.calendar.to = null;
    } else if (
      operator !== null &&
      this.betweenOperators[data.operator] &&
      !this.betweenOperators[operator]
    ) {
      data.value = data.from;
      data.input.value = data.input.from;
      data.calendar.value = data.calendar.from;
      data.from = data.to = null;
      data.input.from = data.input.to = null;
      data.calendar.from = data.calendar.to = null;
    } else if (operator === null) {
      data.value = data.from = data.to = null;
      data.input.value = data.input.from = data.input.to = null;
      data.calendar.value = data.calendar.from = data.calendar.to = null;

      // OMS-29892
      let valueComponent = this.editableColumnDropdownMap.get(data);
      if (valueComponent instanceof BfxMultiSelectorComponent) valueComponent.clearAll();
    }

    data.operator = operator;

    this.updateTimeMask(data);
    this.updateActiveRowState(data);
    this.updateBetweenOperatorState(data);

    this.cd.detectChanges();
  }

  onMouseDown(event: MouseEvent) {
    logger.out.info("arguments: %O", arguments);
  }

  public shouldSave(): boolean {
    return false;
  }

  public createQueryGroup(filter: BfxBlotterFilter): CubiqTS.QueryGroupImpl {
    let outerGroup: CubiqTS.QueryGroupImpl = new CubiqTS.QueryGroupImpl();
    let innerGroup: CubiqTS.QueryGroupImpl = new CubiqTS.QueryGroupImpl();

    outerGroup.condition = CubiqTS.Condition.OR;
    outerGroup.groups = [];
    let dropDownSelection: string = this.selectorService.filterSelection;

    for (let i: number = 0; i < filter.conditions.length; i++) {
      let condition: BfxBlotterFilterCondition = filter.conditions[i];

      if (condition.or || outerGroup.groups.length == 0) {
        innerGroup = new CubiqTS.QueryGroupImpl();
        innerGroup.condition = CubiqTS.Condition.AND;
        outerGroup.groups.push(innerGroup);
        innerGroup.rules = [];
      }

      if (!condition.add && !condition.or) {
        let rule: CubiqTS.QueryRuleImpl = new CubiqTS.QueryRuleImpl();
        rule.operator = condition.operatorData.value;
        rule.field = condition.conditionData.value;

        let values: Array<any> = [];
        if (this.betweenOperators[condition.operatorData.value]) {
          values = [condition["from"], condition["to"]];
        } else if (Constants.OBJECT_COLUMN_FILTER_OPS.indexOf(condition.operatorData.value) < 0) {
          values = [condition.value];
        } else {
          values = condition.value;
        }

        let columnDef: BfxColDef = this.columns[condition.conditionData.value] as BfxColDef;
        if (Constants.DATE_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
          values = values.map((r) => r.getTime() + "");
        } else if (Constants.NUMBER_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
          values = values.map((r) => r + "");
        } else if (Constants.OBJECT_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
          values = values.map((r) => r.value + "");
          if (
            columnDef.columnFilterType == Constants.OBJECT_CURRENCY_PAIR_GROUP_COLUMN_FILTER_TYPE &&
            dropDownSelection == "1"
          )
            values.unshift(this.ccyPairGroupFirst);
        } else if (Constants.BOOLEAN_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
          // values = values.map(r => r.value ? 'true' : 'false');
          values = values.map((r) => r);
        }

        rule.values = values;

        innerGroup.rules.push(rule);
      }
    }

    for (let i: number = 0; i < outerGroup.groups.length; i++) {
      let group: CubiqTS.QueryGroupImpl = outerGroup.groups[i];
      if (group.rules.length == 0) {
        outerGroup.groups.splice(i, 1);
      }
    }

    if (outerGroup.groups.length == 1) {
      outerGroup = innerGroup;
    }

    return outerGroup;
  }

  public save(): void {}

  public parseSwitchValue(value: any): number {
    return value === "true" ? 1 : 0;
  }

  public displayDropDown(event: any): void {
    this.selectorService.passKeyDownEven(event);
  }

  public focusTriggered(event, ref, val) {
    if (ref) ref.hasFocus = val;
  }

  public onKeydown(event, data) {
    switch (event.which) {
      case 13:
        event.preventDefault();
        break;
    }
  }

  public parseConditions(conditions) {
    conditions.forEach((condition: BfxBlotterFilterCondition) => {
      if (
        this.columnFilterTypes[condition.conditionData.value] == "NUMBER" ||
        this.columnFilterTypes[condition.conditionData.value] == "INT" ||
        this.columnFilterTypes[condition.conditionData.value] == "PERCENTAGE"
      ) {
        if (condition.value != null) {
          if (typeof condition.value === "number" || typeof condition.value === "string") {
            condition.value = new BigNumber(condition.value);
          }
        } else {
          if (typeof condition["from"] === "number" || typeof condition["from"] === "string") {
            condition["from"] = new BigNumber(condition["from"]);
          }
          if (typeof condition["to"] === "number" || typeof condition["to"] === "string") {
            condition["to"] = new BigNumber(condition["to"]);
          }
        }
      }
    });
    return conditions;
  }

  public updateTooltip(data, value: string, valueField = `value`): void {
    if (value && typeof value === "string" && value.length >= 13) {
      data.showTooltip[valueField] = true;
    } else {
      data.showTooltip[valueField] = false;
    }
  }

  public updateTimeMask(data: BfxFindFilterCondition): void {
    let timeInput = this.editableColumnTimeInputMap.get(data);

    if (timeInput != null) {
      if (timeInput.from != null) {
        timeInput.from.value = data.from;
      }
      if (timeInput.to != null) {
        timeInput.to.value = data.to;
      }
      if (timeInput.value != null) {
        timeInput.value.value = data.value;
      }
      this.cd.detectChanges();
    }
  }

  public getText(rowData, type = "undefined", valueField = `value`) {
    if (rowData[valueField] instanceof Date) {
      return CubiqTS.moment(rowData[valueField]).format("DD MMM YYYY");
    } else if (rowData[valueField] instanceof CubiqTS.BigNumber) {
      this.updateTooltip(rowData, rowData[valueField].toString(), valueField);
      if (type === "RATE") {
        return rowData[valueField].toString();
      }

      if (
        rowData["fieldName"] == "marketSpot" ||
        rowData["fieldName"] == "clientSpot" ||
        rowData["fieldName"] == "requestRt" ||
        rowData["fieldName"] == "marketAllIn" ||
        rowData["fieldName"] == "clientAllIn"
      ) {
        return rowData[valueField].toString();
      }

      return this.decimalFormatter.transform(rowData[valueField].toString());
    } else if (
      rowData[valueField] &&
      rowData.input &&
      rowData.input[valueField] &&
      BfxFindFilterDateComparitor[rowData[valueField]] === rowData.input[valueField].value
    ) {
      return rowData.input[valueField].label;
    } else if (
      rowData["fieldName"] == "timezoneCd" &&
      rowData[valueField] &&
      this.timezoneCdSuggestions.value.some((elem) => elem.value == rowData[valueField].value)
    ) {
      return rowData[valueField].label;
    }

    if (valueField === `value`) {
      return rowData.toString();
    } else {
      return rowData[valueField] ? rowData[valueField].toString() : "";
    }
  }

  public onTabHeading($event, outerDt, headerData, headerIndex, headerToggle, isRowExpanded) {
    logger.out.info(`${this.constructor.name}.onTabHeading %O`, $event);

    if ($event.shiftKey == true && headerIndex == 0) {
      $event.preventDefault();
    } else if ($event.shiftKey == false && isRowExpanded) {
      let data = headerData.filterConditions[0];
      let dt: DataTable = this.dtExpandedQueryList.toArray()[headerData.expandedIndex];
      let proxyElement = DomHandler.findSingle(dt.el.nativeElement, ".find__dt_first_cell");

      // don't, it breaks tab after shift tab to heading
      // $event.preventDefault();

      if (proxyElement) {
        this.wrapTabCancelableTimeout(
          setTimeout(() => {
            dt.moveToNextCell({
              shiftKey: false,
              target: proxyElement,
              preventDefault: () => {},
            } as any);

            this.cleanupTabCancelableTimeout();
          }, 4),
        );
      }
    } else if (headerIndex == this.data.length - 1) {
      $event.preventDefault();

      let headerToggleElement = this.headerToggleElements.toArray()[0];

      headerToggleElement.nativeElement.focus();
    }
  }

  public tabProxyToHeading(event, data, rowIndex: number) {
    if (event.shiftKey && rowIndex == 0 && data.parentIndex >= 0) {
      let headerToggleElement = this.headerToggleElements.toArray()[data.parentIndex];
      event.preventDefault();
      headerToggleElement.nativeElement.focus();
    }
  }

  public onTabSelector(
    event: KeyboardEvent | null,
    data: BfxFindFilterCondition,
    outerDt: DataTable,
    outerRowIndex: number,
    dt: DataTable,
    rowIndex: number,
    col,
    el: any,
  ) {
    let passthrough = false;
    let realTarget = this.editableColumnOperatorMap.get(data)
      ? this.editableColumnOperatorMap.get(data)
      : dt.editingCell;

    if (realTarget instanceof BfxAmountSpinnerComponent) {
      realTarget = realTarget.el.nativeElement;
    } else if (realTarget instanceof BfxRateSpinnerComponent) {
      realTarget = realTarget.el.nativeElement;
    } else if (realTarget instanceof BfxAutoCompleteComponent) {
      realTarget = realTarget.el.nativeElement;
    }

    let tabEvent: any = {
      shiftKey: event != null ? event.shiftKey : false,
      target: realTarget,
      preventDefault: function () {},
      which: event != null ? event.which : null,
    };

    this.closeCell(dt);

    this.cancelTabCancelableTimeout();

    if (!realTarget) {
      return;
    } else if (event && event.shiftKey && rowIndex > 0) {
      this.wrapTabCancelableTimeout(
        setTimeout(() => {
          dt.moveToPreviousCell(tabEvent);
          this.cleanupTabCancelableTimeout();
        }, 4),
        setTimeout(() => {
          dt.moveToPreviousCell(tabEvent);
          this.cleanupTabCancelableTimeout2();
        }, 8),
      );
    } else if ((!event || !event.shiftKey) && data.index <= dt.value.length - 1) {
      this.wrapTabCancelableTimeout(
        setTimeout(() => {
          dt.moveToNextCell(tabEvent);
          this.cleanupTabCancelableTimeout();
        }, 4),
      );
    } else if (event && event.shiftKey && rowIndex == 0) {
      let headerToggleElement = this.headerToggleElements.toArray()[data.parentIndex];

      this.wrapTabCancelableTimeout(
        setTimeout(() => {
          headerToggleElement.nativeElement.focus();
          this.cleanupTabCancelableTimeout();
        }, 4),
      );
    }

    if (!passthrough) event.preventDefault();
  }

  public onTabValue(
    event,
    data: BfxFindFilterCondition,
    outerDt: DataTable,
    outerRowIndex: number,
    dt: DataTable,
    rowIndex: number,
    col,
    ref: any,
  ) {
    let passthrough = false;
    let realTarget = this.editableColumnValueMap.get(data)
      ? this.editableColumnValueMap.get(data)
      : dt.editingCell;

    if (realTarget instanceof BfxAmountSpinnerComponent) {
      realTarget = realTarget.el.nativeElement;
    } else if (realTarget instanceof BfxRateSpinnerComponent) {
      realTarget = realTarget.el.nativeElement;
    } else if (realTarget instanceof BfxAutoCompleteComponent) {
      realTarget = realTarget.el.nativeElement;
    }

    let tabEvent: any = {
      shiftKey: event.shiftKey,
      target: realTarget,
      preventDefault: function () {},
      which: event.which,
    };

    this.closeCell(dt);

    this.cancelTabCancelableTimeout();

    if (!realTarget) {
      return;
    } else if (event.shiftKey && rowIndex >= 0) {
      this.wrapTabCancelableTimeout(
        setTimeout(() => {
          dt.moveToPreviousCell(tabEvent);
          this.cleanupTabCancelableTimeout();
        }, 4),
      );
    } else if (!event.shiftKey && data.index < dt.value.length - 1) {
      this.wrapTabCancelableTimeout(
        setTimeout(() => {
          dt.moveToNextCell(tabEvent);
          this.cleanupTabCancelableTimeout();
        }, 4),
      );
    } else if (event.shiftKey && rowIndex == 0 && data.parentIndex == 0) {
      let headerToggleElement = this.headerToggleElements.toArray()[0];

      headerToggleElement.nativeElement.focus();
    } else if (
      data.index == dt.value.length - 1 &&
      data.parentIndex < this.headerToggleElements.length - 1
    ) {
      let headerToggleElement = this.headerToggleElements.toArray()[data.parentIndex + 1];

      headerToggleElement.nativeElement.focus();
    }

    if (!passthrough) event.preventDefault();
  }

  public closeCell(dt: any) {
    // do this manaully & synchonously to prevent autoclose of opening
    if (dt != null && typeof dt.closeCell == "function") dt.closeCell(true);
    else logger.out.info(`%O`, dt);

    this.onCloseCellEvent();
  }

  public proxyOnTabValue(data, outerDt, outerRowIndex, dt, rowIndex, col, ref, field = "value") {
    // almost a bind- need event later
    // return this.onTabValue.bind(this, [data, j, dt]);
    const proxyTarget = this;

    let proxyTab = function proxiedOnTabValueFn() {
      const args = Array.from(arguments);
      //console.assert(args.length === 1, `onTabValue proxy call has invalid argument length ${args.length}`);
      args.push(data, outerDt, outerRowIndex, dt, rowIndex, col, ref);
      proxyTarget.onTabValue.apply(proxyTarget, args);
    };
    if (field == "value") {
      data.proxyTabValue = proxyTab;
    } else if (field == "to") {
      data.proxyTabTo = proxyTab;
    }
    return proxyTab;
  }

  public proxyOnTabSelector(data, outerDt, outerRowIndex, dt, rowIndex, col, ref) {
    // almost a bind- need event later
    // return this.onTabValue.bind(this, [data, j, dt]);
    const proxyTarget = this;

    data.proxyTabSelector = function proxiedOnTabValueFn() {
      const args = Array.from(arguments);
      //console.assert(args.length === 1, `onTabValue proxy call has invalid argument length ${args.length}`);
      // args.push(null, data, outerDt, outerRowIndex, dt, rowIndex, col, ref);
      proxyTarget.onTabSelector.apply(proxyTarget, [
        args[0],
        data,
        outerDt,
        outerRowIndex,
        dt,
        rowIndex,
        col,
        ref,
      ]);
    };

    return data.proxyTabSelector;
  }

  public onEnterValue(dt) {
    dt.closeCell();

    this.selectSearch.emit();
  }

  public toggleRow(outerDt: any, headerData, $event, headerIndex): void {
    if (!this.isDataPrimed) {
      return;
    }

    outerDt.toggleRow(headerData, $event);

    if (!headerData.isRowExpanded) {
      headerData.isRowExpanded = true;
      headerData.expandedIndex = this.dtExpandedQueryList.length;
    } else {
      let unexpandedIndex = headerData.expandedIndex;

      this.data.forEach((headerData) => {
        if (headerData.expandedIndex > unexpandedIndex) {
          headerData.expandedIndex = headerData.expandedIndex - 1;
        }
      });

      headerData.isRowExpanded = false;
      headerData.expandedIndex = -1;
    }

    headerData.filterConditions.forEach((filterCondition) => {
      filterCondition.hasRowExpanded = true;
    });

    setTimeout(() => {
      this.expandedChange.emit();
    }, 4);

    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      // OMS-30280 click document level click to close open autocomplete
      try {
        outerDt.el.nativeElement.ownerDocument.dispatchEvent(new Event("click"));
      } catch (e) {
        // best effort only - skip logging error
      }
    }
  }

  /**
   * Callback use for initialisation when a cell in being edited
   * @param sectionIndex
   * @returns
   */
  public onEditInit($event, sectionIndex: number): any {
    let implictOperator = false;
    this.currentEditableInit = true;

    if (this.currentEditableData != $event.data) {
      this.onCloseCellEvent();
    }

    this.currentEditableColumn = $event.column;
    this.currentEditableData = $event.data;
    this.currentEditableSection = sectionIndex;

    if ("value" !== $event.column.field) {
      this.wrapTabCancelableTimeout(
        setTimeout(() => {
          let operatorDropdown = this.editableColumnOperatorMap.get($event.data);

          if (!operatorDropdown) {
            return;
          }

          operatorDropdown.focusInput();

          this.cleanupTabCancelableTimeout();
        }, 4),
        setTimeout(() => {
          let operatorDropdown = this.editableColumnOperatorMap.get($event.data);

          if (!operatorDropdown) {
            return;
          }

          operatorDropdown.handleDropdownClick();

          operatorDropdown.show();

          operatorDropdown.alignPanel();

          this.cleanupTabCancelableTimeout2();
        }, 8),
      );

      return;
    }

    if (!$event.data.hasOperator && "value" === $event.column.field) {
      switch ($event.data.availableOperators) {
        case BfxFindFilterOperatorSet.InNotIn:
          $event.data.operator = CubiqTS.Operator.In;
          implictOperator = true;
          break;
        case BfxFindFilterOperatorSet.All:
        case BfxFindFilterOperatorSet.Equal:
        case BfxFindFilterOperatorSet.EqualNotEqual:
        default:
          $event.data.operator = CubiqTS.Operator.Equal;
          implictOperator = true;
          break;
      }
      $event.data.implictOperator = implictOperator;
    } else {
      $event.data.implictOperator = false;
    }

    this.currentEditableInit = false;

    if (this.editableColumnDropdownMap.has($event.data)) {
      let dropdown = this.editableColumnDropdownMap.get($event.data);
      this.currentEditableDropdownData = $event.data;

      if (dropdown instanceof BfxAutoCompleteComponent) {
        this.wrapTabCancelableTimeout(
          setTimeout(() => {
            dropdown.focusInput();
            dropdown.handleDropdownClick(null);
            dropdown.show();
            this.cleanupTabCancelableTimeout();
          }, 4),
          setTimeout(() => {
            this.cd.detectChanges();
            dropdown.alignPanel();
            this.cleanupTabCancelableTimeout2();
          }, 8),
        );
      } else {
        this.wrapTabCancelableTimeout(
          setTimeout(() => {
            dropdown.showOptionsOnClick();
            this.cleanupTabCancelableTimeout();
          }, 4),
          setTimeout(() => {
            dropdown.showDropdown();
            this.cleanupTabCancelableTimeout2();
          }, 8),
        );
      }
    } else if (this.editableColumnInputMap.has($event.data)) {
      let input = this.editableColumnInputMap.get($event.data);

      this.wrapTabCancelableTimeout(
        setTimeout(() => {
          input.focus();
          this.cleanupTabCancelableTimeout();
        }, 4),
      );
    } else if (this.columnFilterTypes[$event.data.conditionData.value] === "DATE") {
      let component = "autoComplete";
      let field = $event.data.operator === CubiqTS.Operator.Between ? "from" : "value";

      if (
        "icon-calendar_month" === this._dateClickComponent ||
        ($event.data.operator !== CubiqTS.Operator.Equal &&
          this._dateClickComponent !== "icon-triangle_down")
      ) {
        component = "calendar";
      }

      if (this._dateClickField) field = this._dateClickField;

      this._dateClickComponent = null;
      this._dateClickField = null;

      if (component === "autoComplete") {
        let autoComplete = this.editableColumnCalendarMap.get($event.data)[component][field];
        // Component may not have an autocomplete if operator does not support it
        this.wrapTabCancelableTimeout(
          setTimeout(() => {
            if (!autoComplete) {
              autoComplete = this.editableColumnCalendarMap.get($event.data)[component][field];
            }

            if (autoComplete) {
              autoComplete.focusInput();
              autoComplete.handleDropdownClick();
              autoComplete.show();
            }
            this.cleanupTabCancelableTimeout();
          }, 8), // This time must be after the focus-editable time
          setTimeout(() => {
            if (!autoComplete) {
              autoComplete = this.editableColumnCalendarMap.get($event.data)[component][field];
            }
            this.cd.detectChanges();
            if (autoComplete) {
              autoComplete.alignPanel();
            }
            this.cleanupTabCancelableTimeout2();
          }, 10),
        );
      } else {
        let calendar = this.editableColumnCalendarMap.get($event.data)[component][field];
        this.wrapTabCancelableTimeout(
          setTimeout(() => {
            calendar.showOverlay();
            this.cd.detectChanges();
            this.cleanupTabCancelableTimeout();
          }, 4),
          setTimeout(() => {
            calendar.alignOverlay();
            this.cleanupTabCancelableTimeout2();
          }, 8),
        );
      }
      this.currentEditableDropdownData = $event.data;
    } else if (this.columnFilterTypes[$event.data.conditionData.value] === "TIME") {
      let field = $event.data.operator === CubiqTS.Operator.Between ? "from" : "value";
      let target: string = "inputMask";
      let timeInput;
      if (this._timeClickField) field = this._timeClickField;
      if (this._timeClickComponent) target = this._timeClickComponent;

      timeInput = this.editableColumnTimeInputMap.get($event.data)[field];

      if (target === "autocomplete") {
        this.wrapTabCancelableTimeout(
          setTimeout(() => {
            this.updateTimeMask($event.data);
            timeInput.inputMask.focused = false;
            this.cleanupTabCancelableTimeout();
          }, 4),
          setTimeout(() => {
            timeInput.timezoneDropdown.handleDropdownClick();
            timeInput.timezoneDropdown.show();
            //timeInput.timezoneDropdown.align();
            //timeInput.timezoneDropdown.inputEL.nativeElement.select();
            this.cleanupTabCancelableTimeout2();
          }, 8),
        );
      } else if (target === "inputMask") {
        this.wrapTabCancelableTimeout(
          setTimeout(() => {
            timeInput.inputMask.focus();
          }, 4),
        );
      }
    } else {
      this.currentEditableDropdownData = null;
    }
  }

  public focusEditableInput(editable, data): any {
    this.editableColumnInputMap.set(data, editable);
    this.editableColumnValueMap.set(data, editable);
  }

  public focusEditableDropdown(editable, data): any {
    this.editableColumnDropdownMap.set(data, editable);
    this.editableColumnValueMap.set(
      data,
      editable.elementRef ? editable.elementRef.nativeElement : editable.el.nativeElement,
    );
  }

  public focusEditableOperator(operator, data): any {
    this.editableColumnOperatorMap.set(data, operator);
  }

  /**
   * Callback when a Date editor component has been initialised
   * @param editable
   * @param data
   * @param field
   */
  public focusEditableDate(
    editable,
    data,
    component: string = "autoComplete",
    field = "value",
  ): any {
    let a = this.editableColumnCalendarMap.get(data);
    if (!a)
      a = {
        calendar: {},
        autoComplete: {},
      };
    a[component][field] = editable;

    if (component == "calendar" && a.calendar.value) {
      a.calendar.value.icon = "fa icon-calendar_month";
    }

    this.editableColumnCalendarMap.set(data, a);
  }

  public focusEditableTime(editable, data, field: string = "value"): any {
    let a = this.editableColumnTimeInputMap.get(data);
    if (!a)
      a = {
        value: null,
        from: null,
        to: null,
      };
    a[field] = editable;

    this.editableColumnTimeInputMap.set(data, a);

    this.updateTimeMask(data);
  }

  public focusEditableBetweenProxy(editable, data, from, to): any {
    editable.focus = function () {
      // no-op proxy element's focus to prevent dt behaviour
    };

    this.editableColumnBetweenProxyMap.set(data, {
      proxy: editable,
      from: from,
      to: to,
    });

    // used only to calc parent cell.
    this.editableColumnValueMap.set(data, editable);
  }

  public focusEditableValue(editable, data) {
    // used only to calc parent cell.
    this.editableColumnValueMap.set(data, editable);
  }

  public dateClick(component, field = "value") {
    this._dateClickComponent = component;
    this._dateClickField = field;
  }

  public timezoneClick(component: string, field = "value") {
    this._timeClickComponent = component;
    this._timeClickField = field;
  }

  public proxyRowClick($event) {
    if (!$event.originalEvent?.target) {
      return;
    }
    setTimeout(() => {
      if (this.editableColumnBetweenProxyMap.has($event.data)) {
        // If we've pressed the icons to show the dropdown, try to set focus to the first time field as well
        const target: HTMLElement = $event.originalEvent.target;
        let betweenEl = this.editableColumnBetweenProxyMap.get($event.data);

        // Our read-only buttons have marker classes to indicate the time
        let isFrom: boolean = target.classList.contains("time-from-marker");
        if (!isFrom) {
          const fromIcons = DomHandler.find(betweenEl.from, "i");
          isFrom = fromIcons.indexOf(target) !== -1;
        }

        let isTo: boolean = false;
        if (!isFrom) {
          isTo = target.classList.contains("time-to-marker");
          if (!isTo) {
            const toIcons = DomHandler.find(betweenEl.to, "i");
            isTo = toIcons.indexOf(target) !== -1;
          }
        }

        // 2 booleans, if either one is true then we set the focus
        let focusable = null;
        if (isFrom) {
          focusable = DomHandler.findSingle(betweenEl.from, ".ui-cell-editor input");
        } else if (isTo) {
          focusable = DomHandler.findSingle(betweenEl.to, ".ui-cell-editor input");
        }
        if (focusable) {
          setTimeout(() => DomHandler.invokeElementMethod(focusable, "focus"), 4);
        }
      }
    }, 50);
  }

  public onCloseCellEvent(sectionIndex: number = null): void {
    if (
      this.currentEditableData &&
      this.currentEditableData.implictOperator &&
      this.currentEditableData.hasPartialValue === false &&
      this.hasPendingCancelableTimeout() === false
    ) {
      this.currentEditableData.implictOperator = false;
      this.currentEditableData.operator = null;
    } else if (
      this.currentEditableData &&
      this.currentEditableData.implictOperator &&
      this.currentEditableData.hasPartialValue === true
    ) {
      this.currentEditableData.implictOperator = false;
      this.currentEditableData.input.operator = this.currentEditableData.operator;
    }

    if (this.currentEditableData) {
      this.updateActiveRowState(this.currentEditableData);
    }

    if (
      sectionIndex == null ||
      this.currentEditableSection == null ||
      sectionIndex == this.currentEditableSection
    ) {
      this.currentEditableColumn = null;
      this.currentEditableData = null;
      this.currentEditableSection = null;
    }

    this.cd.detectChanges();

    this.expandedChange.emit();
  }

  public onDropdownClose(dt, data): void {
    dt.closeCell();
  }

  public onDatepickerOpen(dt, data, valueField = `value`) {
    // no op
  }

  public getCloseCellEventData(dt: any): any {
    return {
      dt: dt,
      isAllowCloseEventFn: () => {
        let dropdown = this.editableColumnDropdownMap.get(this.currentEditableData);

        return (
          !this.currentEditableInit &&
          this.currentEditableDropdownData &&
          (!dropdown || (dropdown && !dropdown.showOptions))
        );
      },
    };
  }

  /**
   * CAlled from the BFXModelChangeDirective
   * @param ref
   * @param data
   * @param field
   */
  public handleModelChange(value: BigNumber, data, field = "value") {
    // added because of the '.' overwrite OMS-26650
    if (
      data[field] == null ||
      value == null ||
      (data[field] != null && value != null && !(<BigNumber>data[field]).isEqualTo(value))
    ) {
      data[field] = value;

      this.updateActiveRowState(data);

      this.cd.detectChanges();
    }
  }

  public updateActiveRowState(data) {
    let handledActive = false;
    let handledInvalidValue = false;

    if (!this.activeRowMap.has(data.parentIndex))
      this.activeRowMap.set(data.parentIndex, new Set<number>());
    if (!this.invalidValueRowMap.has(data.parentIndex))
      this.invalidValueRowMap.set(data.parentIndex, new Set<number>());

    let isActive = data.hasOperator && data.hasValue;
    let isAlreadyActive = this.activeRowMap.get(data.parentIndex).has(data.index);
    let isInvalidValue = data.hasOperator && data.hasInvalidValue;
    let isAlreadyInvalidValue = this.invalidValueRowMap.get(data.parentIndex).has(data.index);

    if ((isActive && isAlreadyActive) || (!isActive && !isAlreadyActive)) {
      handledActive = true;
    } else if (isActive && !isAlreadyActive) {
      this.activeRowMap.get(data.parentIndex).add(data.index);
    } else if (!isActive && isAlreadyActive) {
      this.activeRowMap.get(data.parentIndex).delete(data.index);
    }

    if ((isInvalidValue && isAlreadyInvalidValue) || (!isInvalidValue && !isAlreadyInvalidValue)) {
      handledInvalidValue = true;
    } else if (isInvalidValue && !isAlreadyInvalidValue) {
      this.invalidValueRowMap.get(data.parentIndex).add(data.index);
    } else if (!isInvalidValue && isAlreadyInvalidValue) {
      this.invalidValueRowMap.get(data.parentIndex).delete(data.index);
    }

    if (handledActive && handledInvalidValue) return;

    // this controls button availablity
    let hasActiveRow = false;
    for (let activeRowSet of this.activeRowMap.values()) {
      if (activeRowSet.size > 0) {
        hasActiveRow = true;
        break;
      }
    }
    let hasInvalidValueRow = false;
    for (let invalidValueSet of this.invalidValueRowMap.values()) {
      if (invalidValueSet.size > 0) {
        hasInvalidValueRow = true;
        break;
      }
    }
    this.hasActiveRow = hasActiveRow && !hasInvalidValueRow;

    // css helper
    let activeRows = [...this.activeRowMap.get(data.parentIndex)].reduce((str, row) => {
      if (!str) return row.toString();

      return str + " " + row;
    }, "");

    const parentTable = this.getParentTableForData(data);
    if (parentTable) {
      parentTable.el.nativeElement.dataset.activeRows = activeRows;
    }

    // css helper
    let invalidValueRows = [...this.invalidValueRowMap.get(data.parentIndex)].reduce((str, row) => {
      if (!str) return row.toString();

      return str + " " + row;
    }, "");

    if (parentTable) {
      parentTable.el.nativeElement.dataset.invalidValueRows = invalidValueRows;
    }
  }

  /**
   * Get the Table componentt associated with the parentIndex attribute of the input data
   * @param data
   * @returns
   */
  private getParentTableForData(data): DataTable {
    if (data && data.parentIndex !== null) {
      const indexId = data.parentIndex;
      const found = this.data.find((filterData) => filterData.id == indexId);
      if (found) {
        return found.dt;
      }
    }
    return null;
  }

  public updateBetweenOperatorState(data) {
    if (!this.betweenOperatorRowsMap.has(data.parentIndex))
      this.betweenOperatorRowsMap.set(data.parentIndex, new Set());

    if (data.hasOperator && CubiqTS.Operator.Between === data.operator) {
      this.betweenOperatorRowsMap.get(data.parentIndex).add(data.index);
    } else {
      this.betweenOperatorRowsMap.get(data.parentIndex).delete(data.index);
    }

    let betweenOperatorRows = [...this.betweenOperatorRowsMap.get(data.parentIndex)].reduce(
      (str, row) => {
        if (!str) return row.toString();

        return str + " " + row;
      },
      "",
    );

    const parentTable = this.getParentTableForData(data);

    if (parentTable) {
      parentTable.el.nativeElement.dataset.betweenOperatorRows = betweenOperatorRows;
    }
  }

  public identifyFilterData(i, filterContent) {
    return filterContent.id;
  }

  public identifyFilterContents(i, filterContent) {
    return filterContent.id;
  }

  public wrapTabCancelableTimeout(id, id2 = null) {
    clearTimeout(this._tabCancelableTimeoutId);
    clearTimeout(this._tabCancelableTimeoutId2);
    this._tabCancelableTimeoutId = id;
    this._tabCancelableTimeoutId2 = id2;
  }

  public cancelTabCancelableTimeout() {
    clearTimeout(this._tabCancelableTimeoutId);
    clearTimeout(this._tabCancelableTimeoutId2);
    this._tabCancelableTimeoutId = null;
    this._tabCancelableTimeoutId2 = null;
  }

  public cleanupTabCancelableTimeout() {
    this._tabCancelableTimeoutId = null;
  }

  public cleanupTabCancelableTimeout2() {
    this._tabCancelableTimeoutId2 = null;
  }

  public hasPendingCancelableTimeout() {
    return this._tabCancelableTimeoutId !== null || this._tabCancelableTimeoutId2 !== null;
  }

  private currentSelectedClientsIds = [];
  private currentSelectedClientNameIds = [];

  /**
   * stash what clients are currently selected
   * then filtert he client traders based on it
   *
   * (This is because finding them in this.data is cumbersome
   * and very likely to be broken by someone later)
   * @param data
   */
  cacheSelectedClientsIds(data: any, clientTraderField: string) {
    this.currentSelectedClientsIds =
      null == data.value
        ? []
        : data.value.map((clientId) => {
            return clientId.value;
          });
    this.filterVisibleClientTraderData(clientTraderField);
  }

  cacheSelectedClientsNames(data: any, clientTraderField: string) {
    this.currentSelectedClientNameIds =
      null == data.value
        ? []
        : data.value.map((clientName) => {
            let foundClients: Array<CubiqTS.ClientImpl> = this.clientService
              .getBase()
              .lookupClientsForName(clientName.value, 100);
            for (let index = 0; index < foundClients.length; index++) {
              const client = foundClients[index];
              return client.clientId;
            }
          });
    this.filterVisibleClientTraderData(clientTraderField);
  }

  /**
   * Filter the visible client traders to only those associated with selecteed clients, if any
   * Otherwise - show em all
   */
  filterVisibleClientTraderData(clientTraderField: string) {
    let allClientTraders =
      this.objectValues[this.ALL_CLIENT_TRADERS] != null
        ? Array.from(this.objectValues[this.ALL_CLIENT_TRADERS])
        : [];
    let found = allClientTraders;

    if (
      (null != this.currentSelectedClientsIds && this.currentSelectedClientsIds.length > 0) ||
      (null != this.currentSelectedClientNameIds && this.currentSelectedClientNameIds.length > 0)
    ) {
      let foundTraders: Set<any> = new Set<any>();

      let selectedClientIds =
        this.currentSelectedClientsIds != null ? Array.from(this.currentSelectedClientsIds) : [];
      let selectedClientNames =
        this.currentSelectedClientNameIds != null
          ? Array.from(this.currentSelectedClientNameIds)
          : [];
      for (let index = 0; index < allClientTraders.length; index++) {
        const clientTrader: any = allClientTraders[index];
        for (let j = 0; j < clientTrader.clientIds.length; j++) {
          const clientId = clientTrader.clientIds[j];
          if (
            selectedClientIds.indexOf(clientId) != -1 ||
            selectedClientNames.indexOf(clientId) != -1
          ) {
            foundTraders.add(clientTrader);
          }
        }
      }

      found = Array.from(foundTraders.values());
    }

    this.objectValues[clientTraderField] = found;
  }

  public abstract resetVisibleClientTraderData(): void;

  /**
   * For dynamically generated attribute names, we may need to define a tooltip
   * to show overflowed text.
   * We cache text content of node against whether the node is overflowed to prevent clientWidth
   * being recalculated all the time which causes reflow
   * @param rowData For superl
   * @returns
   */
  public getAttributeTooltip(
    refEl: HTMLElement,
    rowData: BfxFindFilterCondition,
    col: any,
  ): string {
    if (refEl) {
      const text = refEl.textContent;
      if (text) {
        let isOverflowed: boolean = this.attributeOverflowMap.get(text);
        if (isOverflowed === undefined) {
          isOverflowed = refEl.scrollWidth > refEl.clientWidth;
          this.attributeOverflowMap.set(text, isOverflowed);
        }
        if (isOverflowed) {
          return rowData[col.field];
        }
      }
    }
    return "";
  }

  /**
   * Reserved for implementation in ancestor implementations
   * @param columnDef
   */
  protected processProductPrimeData(columnDef: BfxColDef): void {
    // NOOP
  }
}
